const env = process.env.NODE_ENV || "development";

const isProduction = env !== "development";

export const config = {
  API_URL: "https://bot108.heimat24.de/apps/bot_findus-main/api/",
};

export default config;
